import { graphql } from "../gql";

export const archiveFileMutationDoc = graphql(`
  mutation archiveFile($id: ID!) {
    archiveFile(id: $id) {
      ...FileFragment
    }
  }
`);
